import { useState, useEffect, useContext } from "react";
import { AnimatePresence } from "framer-motion";
import ChatContext from "@/context/chatContext";
import getChat from "@/services/Users/chatService";
import { getMessages } from "@/services/Users/messagesService";
import Cookies from "js-cookie";
import socketIO from "@/config/socketIO";
import useChat from "@/hooks/Users/useChat";
import ChatList from "@/components/chat/ChatList";
import ChatWindow from "@/components/chat/ChatWindow";

const getAccountData = () => {
  const rawData = Cookies.get("accountData");
  if (!rawData) return null;
  try {
    return JSON.parse(decodeURIComponent(rawData));
  } catch (error) {
    console.error("Error parsing accountData:", error);
    return null;
  }
};

const ChatPage = () => {
  const { chatData, setChatData } = useContext(ChatContext);
  const [userData, setUserData] = useState(null);
  const [activeChat, setActiveChat] = useState(null);
  const [showChatsView, setShowChatsView] = useState(true);
  const [chats, setChats] = useState([]);

  const [message, setMessage, isConnected, messages, sendMessage, setMessages, joinRoom, enterChat] = useChat();

  useEffect(() => {
    const data = getAccountData();
    setUserData(data);
  }, []);

  useEffect(() => {
    if (!userData) return;

    const fetchChats = async () => {
      try {
        const userChats = await getChat(userData._id);
        console.log("Datos recibidos de getChat:", userChats);

        if (!Array.isArray(userChats)) {
          console.error("Error: los datos no son un arreglo. Recibido:", userChats);
          setChats([]); // Evitar errores
          return;
        }

        setChatData(
          userChats.map((chat) => ({
            avatar: chat.contact.avatar ?? "",
            chatId: chat._id,
            contactName: chat.contact?.name,
            userId: userData?._id,
            lastMessage: chat.lastMessage?.message ?? "No hay mensaje",
            unreadMessagesCount: chat.unreadMessagesCount,
          }))
        );
        setChats(userChats);
      } catch (error) {
        console.error("Error en fetchChats:", error);
        setChats([]);
      }
    };

    fetchChats();
  }, [userData, setChatData]);

  useEffect(() => {
    if (chatData[0]?.chatId !== "" && !socketIO.connected) {
      socketIO.connect();
      joinRoom();
    }
  }, [chatData]);

  const handleSelectChat = async (chatId) => {
    setActiveChat(chatId);
    console.log("Chat seleccionado:", chatId);

    try {
      const chatMessages = await getMessages(chatId);
      console.log("Mensajes recibidos:", chatMessages);

      setMessages(chatMessages);
    } catch (error) {
      console.error("Error al obtener mensajes:", error);
      setMessages([]);
    }

    const selectedChat = chatData.find((chat) => chat.chatId === chatId);
    if (selectedChat) {
      const otherChats = chatData.filter((chat) => chat.chatId !== chatId);
      setChatData([selectedChat, ...otherChats]);

      setChats(
        chats.map((chat) =>
          chat._id === chatId ? { ...chat, unreadMessagesCount: 0 } : chat
        )
      );

      enterChat(); // Notificar al servidor que el usuario ha entrado al chat
    } else {
      console.warn("Chat no encontrado en chatData");
    }

    setShowChatsView(false);
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!message.trim() || !activeChat || !userData) return;

    sendMessage(activeChat, userData._id, message);
  };

  const getActiveChatData = () => {
    return chats.find((chat) => chat._id === activeChat) || null;
  };

  const activeChatData = getActiveChatData();

  return ( 
    <div className="flex h-[calc(100vh-64px)] "> {/* Ajusta el padding-top según la altura del Header */}
      <AnimatePresence mode="wait">
        <ChatList chatData={chatData} activeChat={activeChat} handleSelectChat={handleSelectChat} />
      </AnimatePresence>
  
      <AnimatePresence mode="wait">
        <ChatWindow
          activeChatData={activeChatData}
          isConnected={isConnected}
          messages={messages}
          userData={userData}
          message={message}
          setMessage={setMessage}
          handleSendMessage={handleSendMessage}
          setShowChatsView={setShowChatsView}
        />
      </AnimatePresence>
    </div>
  );
  
};

export default ChatPage;
